export default __webpack_public_path__ + "static/media/deletar1.50bf02b6.svg";